<template>
  <!-- 实操计划 -->
  <div class="shicaojihua">
    <PublicCert :logo="Logo6" :type="'jy'" :color="'#36b9bf'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo6 from '@/assets/images/logo6.png'

export default {
  name: 'ShiCaoJiHua',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo6
    }
  }
}
</script>
